module.exports = __webpack_public_path__ + "static/media/flu-vaccines-badge.3ebdd222.png";